/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { Button, Flyout, Toolbar, Tooltip } from 'ca-ui-toolkit';

const BASE_CLASS_NAME = 'flyoutToolbar';

export function eventIsInFloatingToolbar(evt) {
	let e = evt.target;
	while(e) {
		const classList = e.classList;
		if(classList && classList.contains(BASE_CLASS_NAME)) {
			return true;
		}
		e = e.parentElement;
	}
	return false;
}

/**
 * Toolbar flyout
 */
export default class FloatingToolbar extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		const buttons = this.props.buttons.filter(
			({ include }) => _.isUndefined(include) || include()
		);

		if(!buttons.length) {
			return null;
		}

		return (
			<Flyout
				domNodeToAttachTo={document.body}
				triggerNode={this.props.triggerNode}
				className={BASE_CLASS_NAME}
			>
				<Toolbar>{
					buttons.map(({ icon, label, action, otherComponents }, index) =>
						<Tooltip
							key={index}
							title={label}
							orient="top"
						>
							<Button
								iconSize="small"
								variant="icon"
								intent="primary"
								iconLeft={icon}
								aria-label={label}
								onClick={action}
							/>
							{otherComponents ? otherComponents() : null}
						</Tooltip>
					)
				}</Toolbar>
			</Flyout>
		);
	}
}

FloatingToolbar.propTypes = {
	buttons: PropTypes.arrayOf(PropTypes.shape({
		icon: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		action: PropTypes.func.isRequired,
		include: PropTypes.func
	})).isRequired,
	triggerNode: PropTypes.element.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/floatingtoolbar/FloatingToolbar.js